import { lazy } from "react";
import { Navigate, Route } from "react-router-dom";
import Services from "../pages/services";
import ServicesLayout from "../layouts/servicesLayout";

const ServBooks = lazy(() => import("../features/services/servBooks"));
const ServWeb = lazy(() => import("../features/services/servWeb"));
const ServSocial = lazy(() => import("../features/services/servSocial"));
const ServIdentity = lazy(() => import("../features/services/servIdentity"));
const ServAdv = lazy(() => import("../features/services/servAdv"));
const ServPackage = lazy(() => import("../features/services/servPackage"));
const ServBanner = lazy(() => import("../features/services/servBanner"));
const ServPhoto = lazy(() => import("../features/services/servPhoto"));
const ServShows = lazy(() => import("../features/services/servShows"));
const ServProfile = lazy(() => import("../features/services/servProfile"));

export function ServicesRoutes() {
    // Helper function to get default language
    const getDefaultLanguage = () => {
        return localStorage.getItem('i18nextLng') || 'ar';
    };

    return (
        <>
            {/* <Route
                path="/services/servIdentity"
                element={<Navigate to={`/${getDefaultLanguage()}/services/servIdentity`} replace />}
            /> */}

            <Route
                path="services"
                element={<Navigate to={`/${getDefaultLanguage()}/services/`} replace />}
            />
            <Route path="services" element={<ServicesLayout />}>
                <Route index element={<Services />} />
                <Route path="servBooks" element={<ServBooks />} />
                <Route path="servWeb" element={<ServWeb />} />
                <Route path="servSocial" element={<ServSocial />} />
                <Route path="servIdentity" element={<ServIdentity />} />
                <Route path="servPackage" element={<ServPackage />} />
                <Route path="servAdv" element={<ServAdv />} />
                <Route path="servBanner" element={<ServBanner />} />
                <Route path="servPhoto" element={<ServPhoto />} />
                <Route path="servShows" element={<ServShows />} />
                <Route path="servProfile" element={<ServProfile />} />
            </Route>
        </>
    );
}